import { makeStyles } from '@material-ui/core';

var useTooltipStyles = makeStyles(function (_a) {
    var typography = _a.typography;
    return ({
        tooltip: {
            fontSize: typography.pxToRem(16),
        },
    });
});

export { useTooltipStyles };
//# sourceMappingURL=TooltipStyles.js.map
